module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="authority">\r\n  <div class="authority-mask"></div>\r\n  <div class="cont">\r\n    <div class="close-btn"><i class="iconfont icon-guanbi"></i></div>\r\n    <div class="icon"><i class="iconfont icon-gantanhao"></i></div>\r\n    <div class="title">您无权下载</div>\r\n    <div class="btn"><a href="#">去登录</a></div>\r\n  </div>\r\n</div>';

}
return __p
}